import ApolloContainer from './apollo-container';

export default ApolloContainer;
